import styled from 'styled-components';
import { EntranceAnimation, ScaleOut } from '../animations/ModalAnimations';
import { PRIMARY } from '../../const/colors';

export const ModalContainer = styled.div.attrs(props => ({
	className: props.className,
}))`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100000;
    display: flex;
    align-items:center;
    justify-content: center;
    background-color: rgba(0,0,0,0.2);
    backdrop-filter: blur(5px);
    overflow: hidden;
    opacity: 0;
    &.open {
      animation: ${EntranceAnimation} 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }
    
    &.close {
      animation: ${ScaleOut} 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
    }
`;

export const ImgContainer = styled.div.attrs(props => ({
	className: props.className,
}))`
  margin: auto;
  width: 1000px;
  height: 750px;
  background: ${props => props.desk ? `transparent url(https://admin.betsfactory.co/admin/contenido/${props.desk}) 0% 0% no-repeat` : '#fff'};
  //background: ${props => `url(http://masterbets/admin/contenido/${props.desk}) 0% 0% no-repeat`};
  background-size: cover;
  border: 3px solid ${PRIMARY};
  position: relative;
  box-shadow: 0 5px 16px rgba(0,0,0,0.2);

  @media screen and (max-width:1600px) and (max-height: 799px) {
    width: 800px;
    height: 600px;
  }

  @media screen and (max-width: 1080px) {
    width: 700px;
    height: 550px;
  }

  @media screen and (max-width: 768px) {
    width: 600px;
    height: 90%;
    background-image: ${props => props.mob ? `url(https://admin.betsfactory.co/admin/contenido/${props.mob})`:'#fff'};
    //background-image: ${props => `url(http://masterbets/admin/contenido/${props.mob})`};
    background-position: center center;
  }

  @media screen and (max-width: 480px) {
    width: 90%;
    height: 70%;
  }
  @media screen and (max-width: 330px) {
    height: 80%;
  }
`;

export const ImgContainerInfo = styled.div.attrs(props => ({
	className: props.className,
}))`
  margin: auto;
  width: 1000px;
  height: 750px;
  background: ${props => props.desk ? `transparent url(${props.desk}) 0% 0% no-repeat` : '#fff'};
  background-size: cover;
  border: 3px solid ${PRIMARY};
  position: relative;
  box-shadow: 0 5px 16px rgba(0,0,0,0.2);

  @media screen and (max-width:1600px) and (max-height: 799px) {
    width: 800px;
    height: 600px;
  }

  @media screen and (max-width: 1080px) {
    width: 700px;
    height: 550px;
  }

  @media screen and (max-width: 768px) {
    width: 600px;
    height: 90%;
    background-image: ${props => props.mob ? `url(${props.mob})`:'#fff'};
    background-position: center center;
  }

  @media screen and (max-width: 480px) {
    width: 90%;
    height: 70%;
  }
  @media screen and (max-width: 330px) {
    height: 80%;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.22rem;
  right: 1.17rem;
  border-radius: 50%;
  border: 3px solid ${PRIMARY};
  background-color: transparent;
  padding: 0.35rem 0.4rem;
  cursor: pointer;
  svg {
    color: ${PRIMARY};
  }

  @media screen and (max-width: 768px) {
    top: 0.2rem;
    right: 0.2rem;
  }
`;